import React from 'react';
import PropTypes from 'prop-types';
import {getSliderStyle} from './InputSlider.utils';
import style from './style.module.scss';

const INPUT_TYPE_RANGE = 'range';

/**
 * InputSlider
 *  - Type Slider Input
 */
export function InputSlider(props) {
  const onChange = (event) => props.onChange(event.target.valueAsNumber);

  return (
    <input
      type={INPUT_TYPE_RANGE}
      style={getSliderStyle(props)}
      className={`${style.inputSlider} ${props.className}`}
      min={props.min}
      max={props.max}
      value={props.value}
      onChange={onChange}
      autoFocus={true}
    />
  );
}

InputSlider.propTypes = {
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * min value
   */
  min: PropTypes.number,
  /**
   * max value
   */
  max: PropTypes.number,
  /**
   * current value
   */
  value: PropTypes.number,
  /**
   * Function to call on value change
   */
  onChange: PropTypes.func,
};

InputSlider.defaultProps = {};
